import { render, staticRenderFns } from "./PlantList.vue?vue&type=template&id=2544b512&scoped=true&"
import script from "./PlantList.vue?vue&type=script&lang=ts&"
export * from "./PlantList.vue?vue&type=script&lang=ts&"
import style0 from "./PlantList.vue?vue&type=style&index=0&id=2544b512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544b512",
  null
  
)

export default component.exports